var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"consumer":_vm.consumer},on:{"update:consumer":function($event){_vm.consumer=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }